import { useAuthRevoke } from 'api-hooks/employee';
import logout from 'common/utils/auth';
import notification from 'components/common/notification';
import React from 'react';

export default function useLogout() {
  const { mutateAsync } = useAuthRevoke();

  const handleLogout = React.useCallback(
    async (close?: () => void) => {
      try {
        close?.();
        const result = await mutateAsync({});
        notification.success({ message: result.message });
      } catch (e) {
        notification.error({ message: e.message });
      } finally {
        await logout();
      }
    },
    [mutateAsync],
  );

  return handleLogout;
}
